import { CustomType, CustomValuePreview, Id } from "PFTypes";
import { createContext, useContext } from "react";

type CustomValuePreviewContextType = Omit<CustomValuePreview, "customValueId"> & {
  customType: CustomType;
  allowSearch: boolean;
  customValueId: Id | null;
  setSelectedCustomValueId: (value: React.SetStateAction<Id | null>) => void;
  show: boolean;
  isClosing: boolean;
  index: number;
};

export const CustomValuePreviewContext = createContext<CustomValuePreviewContextType>(
  {} as CustomValuePreviewContextType
);

export const useCustomValuePreviewContext = (): CustomValuePreviewContextType => {
  const customValuePreviewContext = useContext<CustomValuePreviewContextType>(CustomValuePreviewContext);

  if (!customValuePreviewContext) {
    throw new Error("useCustomValuePreviewContext must be used within a CustomValuePreviewContextProvider");
  }

  return (customValuePreviewContext || {}) as CustomValuePreviewContextType;
};
